<script>
console.clear();
import { notificationMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import ProfessionalWorkingHoursForm from "./partials/ProfessionalWorkingHoursForm.vue";

export default {
  props: {
    currentEmpresa: {
      type: Object,
      required: true,
    },
    vet_tratamentos: {
      type: Array,
    },
  },
  components: {
    ProfessionalWorkingHoursForm,
  },
  data() {
    return {
      tratamentos: [],
      paymentsDocument: [
        { id: 1, name: "Nota" },
        { id: 2, name: "RPA" },
      ],
      loader: {
        get: false,
      },
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Lista de profissionais",
          href: "/",
          active: true,
        },
        {
          text: "Incluir profissionais",
          href: "/profissionais/insert",
          active: true,
        },
      ],
      profissional: {
        name: null,
        council: null,
        credential: null,
        birth_date: null,
        email: null,
        contact: null,
        specialty: [],
        status: 1,
      },
      logoUrl: "@/assets/crescer.png",
      titleBody: "Inserindo",
      inserindo: true,
      submit: false,
      workingHours: [],
      showReplicateModal: false,
      replicateData: {
        days: [],
        shifts: {
          manha: { start_time: '', end_time: '', enabled: false },
          tarde: { start_time: '', end_time: '', enabled: false },
          noite: { start_time: '', end_time: '', enabled: false }
        }
      },
    };
  },
  validations: {
    profissional: {
      name: {
        required,
      },
      contact: {
        required,
      },
    },
  },
  created() {
    this.tratamentos = this.vet_tratamentos;
  },
  mounted() {
    this.$emit("newTitle", "Incluir Profissional");
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    enabledShifts() {
      return Object.entries(this.replicateData.shifts).filter(([, shiftData]) => 
        shiftData.enabled && shiftData.start_time && shiftData.end_time
      );
    },
  },
  methods: {
    ...notificationMethods,
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.profissional.$error) {
        this.makeToast("danger", "Erro de validação!");
      } else {
        // Incluir horários de atendimento junto com os dados do profissional
        const profissionalData = {
          ...this.profissional,
          working_hours: this.workingHours
        };
        this.$emit("doPost", profissionalData);
      }
    },
    select_specialty(objeto, index){
        console.log(objeto, index)
        console.log(this.profissional.specialty)
    },
    back() {
      this.$emit("back");
    },
    saveWorkingHours(updatedHours) {
      // Em modo de inserção, apenas armazenamos os horários localmente
      // Eles serão enviados junto com o profissional quando o formulário for submetido
      this.workingHours = updatedHours;
      this.makeToast("success", "Horários de atendimento configurados com sucesso!");
    },
    openReplicateModal() {
      this.showReplicateModal = true;
      // Reset form
      this.replicateData = {
        days: [],
        shifts: {
          manha: { start_time: '', end_time: '', enabled: false },
          tarde: { start_time: '', end_time: '', enabled: false },
          noite: { start_time: '', end_time: '', enabled: false }
        }
      };
    },
    closeReplicateModal() {
      this.showReplicateModal = false;
    },
    replicateWorkingHours() {
      if (this.replicateData.days.length === 0) {
        this.makeToast("warning", "Selecione pelo menos um dia da semana");
        return;
      }

      // Verificar se pelo menos um turno está habilitado e preenchido
      const hasValidShift = Object.values(this.replicateData.shifts).some(shift => 
        shift.enabled && shift.start_time && shift.end_time
      );

      if (!hasValidShift) {
        this.makeToast("warning", "Configure pelo menos um turno com horários válidos");
        return;
      }

      // Criar novos horários baseados na replicação
      const newHours = [];
      
      this.replicateData.days.forEach(day => {
        Object.entries(this.replicateData.shifts).forEach(([shiftName, shiftData]) => {
          if (shiftData.enabled && shiftData.start_time && shiftData.end_time) {
            newHours.push({
              day_of_week: day,
              shift: shiftName,
              start_time: shiftData.start_time,
              end_time: shiftData.end_time
            });
          }
        });
      });

      // Atualizar os horários locais
      this.workingHours = [...this.workingHours, ...newHours];
      
      this.makeToast("success", `Horários replicados com sucesso para ${this.replicateData.days.length} dia(s)`);
      this.closeReplicateModal();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <form @submit.prevent="formSubmit" name="formProfissional">
        <div class="form-row col-md-12">
          <div class="form-group col-md-3">
            <label for="name">Nome do profissional:</label>
            <b-form-input
              id="name"
              type="text"
              class="form-control"
              v-model="profissional.name"
              maxlength="100"
              placeholder="Nome do Profissional"
              :class="{ 'is-invalid': submit && $v.profissional.name.$error }"
            ></b-form-input>
            <div v-if="submit && $v.profissional.name.$error" class="invalid-tooltip">
              <span v-if="!$v.profissional.name.required">Por favor, informe o Nome do Profissional!</span>
            </div>
          </div>
          <div class="form-group col-md-3">
            <label for="name">Conselho regional:</label>
            <input
              id="name"
              type="text"
              class="form-control"
              v-model="profissional.council"
              maxlength="6"
              placeholder="Ex: CRM"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="name">Credencial:</label>
            <input
              id="name"
              type="number"
              class="form-control"
              v-model="profissional.credential"
              maxlength="6"
              placeholder="Ex: "
            />
          </div>
          <div class="form-group col-md-3">
            <label for="birth_date">Data de nascimento:</label>
            <input
              id="birth_date"
              type="date"
              class="form-control"
              v-model="profissional.birth_date"
            />
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-4">
            <label for="email">E-mail:</label>
            <input
              id="email"
              type="email"
              class="form-control"
              v-model="profissional.email"
              placeholder="Ex: profisional@email.com"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="contact">Contato telefônico:</label>
            <b-form-input
              id="contact"
              type="tel"
              class="form-control"
              v-mask="'## #####-####'"
              v-model="profissional.contact"
              placeholder="Ex: 12934567889"
              :class="{ 'is-invalid': submit && $v.profissional.contact.$error }"
            ></b-form-input>
            <div v-if="submit && $v.profissional.contact.$error" class="invalid-tooltip">
              <span v-if="!$v.profissional.contact.required">Por favor, informe o Contato telefônico!</span>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label for="documento_pagamento">Forma de pagamento:</label>
            <b-form-select v-model="profissional.payment_document">
              <option v-for="(item, index) in paymentsDocument" :key="index=item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <div class="form-group col-md-4">
            <label for="professional_status">Situação:</label>
            <b-form-select id="professional_status" v-model="profissional.status">
              <option :value="1">Ativo</option>
              <option :value="0">Inativo</option>
            </b-form-select>
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-12">
            <label for="specialty">Especialidades:</label>
            <div class="row">
              <div v-for="(item, index) in tratamentos" :key="index=item.id" class="col-md-4 ">
                <div class="form-check">
                  <input
                    id="specialty"
                    class="form-check-input"
                    v-model="profissional.specialty"
                    @change="select_specialty(item, index)"
                    type="checkbox"
                    :value="index"
                  />
                  <label
                    class="form-check-label"
                    for="specialty-neuropediatria"
                  >
                    {{item.name}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Quadro de Horários de Atendimento -->
        <div class="form-row col-md-12 mt-4">
          <div class="col-md-12">
            <b-card class="mb-3">
              <template #header>
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 class="mb-0">Horários de Atendimento</h5>
                    <small class="text-muted">Configure os horários de disponibilidade do profissional</small>
                  </div>
                  <div>
                    <b-button 
                      variant="outline-primary" 
                      size="sm" 
                      @click="openReplicateModal"
                      class="mr-2"
                    >
                      <i class="ri-copy-line mr-1"></i>
                      Replicar Horário
                    </b-button>
                  </div>
                </div>
              </template>
              <ProfessionalWorkingHoursForm
                :working-hours="workingHours"
                :loading="false"
                :saving="false"
                :show-save-button="false"
                @save="saveWorkingHours"
              />
            </b-card>
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <button
            type="submit"
            class="btn btn-primary"
            style="margin-right: 20px"
          >
            Cadastrar
          </button>
        </div>
      </form>
      
      <!-- Modal de Replicação de Horários -->
      <b-modal
        v-model="showReplicateModal"
        title="Replicar Horários"
        size="lg"
        @hidden="closeReplicateModal"
        ok-title="Replicar"
        cancel-title="Cancelar"
        @ok="replicateWorkingHours"
      >
        <div class="replicate-modal-content">
          <p class="text-muted mb-3">
            Configure os horários que deseja replicar para múltiplos dias da semana.
          </p>
          
          <!-- Seleção de Dias -->
          <div class="mb-4">
            <h6>Selecione os dias da semana:</h6>
            <div class="row">
              <div class="col-md-4" v-for="day in [1,2,3,4,5,6,7]" :key="day">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="`replicate-day-${day}`"
                    :value="day"
                    v-model="replicateData.days"
                  />
                  <label class="form-check-label" :for="`replicate-day-${day}`">
                    {{ $t(`mesages.professional.working_hours.days.${day}`) }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Configuração de Turnos -->
          <div class="mb-3">
            <h6>Configure os turnos:</h6>
            <div class="row">
              <div class="col-md-4" v-for="(shift, shiftName) in replicateData.shifts" :key="shiftName">
                <div class="card">
                  <div class="card-header p-2">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`replicate-shift-${shiftName}`"
                        v-model="shift.enabled"
                      />
                      <label class="form-check-label font-weight-bold" :for="`replicate-shift-${shiftName}`">
                        {{ $t(`mesages.professional.working_hours.shifts.${shiftName}`) }}
                      </label>
                    </div>
                  </div>
                  <div class="card-body p-2" v-if="shift.enabled">
                    <div class="form-group mb-2">
                      <label class="small">Horário de Início:</label>
                      <input
                        type="time"
                        class="form-control form-control-sm"
                        v-model="shift.start_time"
                        :disabled="!shift.enabled"
                      />
                    </div>
                    <div class="form-group mb-0">
                      <label class="small">Horário de Fim:</label>
                      <input
                        type="time"
                        class="form-control form-control-sm"
                        v-model="shift.end_time"
                        :disabled="!shift.enabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Preview dos horários que serão criados -->
          <div v-if="replicateData.days.length > 0 && Object.values(replicateData.shifts).some(s => s.enabled && s.start_time && s.end_time)" class="mt-3">
            <h6>Preview dos horários que serão criados:</h6>
            <div class="alert alert-info">
              <small>
                <strong>Dias selecionados:</strong> {{ replicateData.days.map(d => $t(`mesages.professional.working_hours.days.${d}`)).join(', ') }}<br>
                <strong>Turnos configurados:</strong>
                <ul class="mb-0 mt-1">
                  <li v-for="[shiftName, shiftData] in enabledShifts" :key="shiftName">
                    {{ $t(`mesages.professional.working_hours.shifts.${shiftName}`) }}: {{ shiftData.start_time }} - {{ shiftData.end_time }}
                  </li>
                </ul>
              </small>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
  <!-- </layout> -->
</template>